import React from 'react';
import im from '../../assets/images/Vector (8).svg';
import DetailForm from 'pages/detailForm/DetailForm';
import apiService from 'services/apiService';
import { toast } from 'react-toastify';
import ReasonOfRejection from 'components/common/reasonOfRejection/ReasonOfRejection';
import { useNavigate } from 'react-router-dom';
import StarRating from '../../components/common/rating/StartRating';
import { Rating } from '@mui/material';
import { FaChevronDown } from 'react-icons/fa6';
import { RiStarSmileLine } from 'react-icons/ri';

import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import CustomModal from '../../components/common/connectModal/CustomModal';

const StarIcon = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 5.15377L9.07398 4.56218L6.99737 0L4.92077 4.56218L0 5.15377L3.638 8.57008L2.67593 13.5L6.99737 11.043L11.3241 13.5L10.362 8.57008L14 5.15377Z"
        fill="#F2AE40"
      />
    </svg>
  );
};

const AnnouncementDetail = () => {
  const navigate = useNavigate();

  const saveddata = JSON.parse(localStorage.getItem('rowOriginalData'));

  const [showDescription, setShowDescription] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [activeButton, setActiveButton] = React.useState('All');
  const [savedData, setSavedData] = React.useState('');
  const [detailNodal, setDetailModal] = React.useState('');
  const [rejection, setRejection] = React.useState(false);
  const [ID, setId] = React.useState('');
  const [Loading, setLoading] = React.useState(false);
  const [reviewModal, setreviewModal] = React.useState(false);

  const [showReviews, setShowReviews] = React.useState(false);

  const [isLoading, setIsLoading] = React.useState(true);
  const [answer, setAnswer] = React.useState('');

  const [showModal, setShowModal] = React.useState(false);
  const [modalData, setModalData] = React.useState(null);

  const filteredApplications = savedData?.applications || [];
  const managerRating = detailNodal?.user?.physician?.avg_rating;
  const avgRating = managerRating;

  const user = JSON.parse(localStorage.getItem('user'));
  const [view, setReviews] = React.useState('');

  console.log('showModal', showModal);

  const handleOpenModal = (data) => {
    setModalData(data); // Store the data
    setShowModal(true); // Open the modal
  };

  const fetchData = async (id) => {
    try {
      const response = await apiService.get(`/physician/showPhysician/${id}`);
      setIsLoading(false);
      setReviews(response?.physician);
    } catch (e) {
      setIsLoading(false);
      console.log('Error fetching users:', e);
    }
  };

  const toggleModal = (data) => {
    setDetailModal(data);
    setIsModalOpen(!isModalOpen);
  };

  const capitalizeFirstCharacter = (str) => {
    if (!str) return ''; // Handle empty or undefined strings
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const toggleRejectionModal = (data) => {
    setRejection(!rejection);
    setId(data);
  };

  const handleViewDetailsClick = () => {
    setShowDescription((prev) => !prev);
  };
  const fetchRequests = async (id, activetab) => {
    try {
      const response = await apiService.get(
        `https://dev-apiefficax-zaeroon.ascend.com.sa/api/announced-jobs/${id}?application_status=${activetab}`
      );
      if (response?.code === 200) {
        setSavedData(response?.data);
        setLoading(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const action = async (data, e) => {
    try {
      const payload = {
        application_id: data?._id,
      };

      try {
        const response = await apiService.post(
          `announced-jobs/applicants/shortlist`,
          payload
        );
        if (response?.code === 200) {
          if (e == true) {
            setIsModalOpen(!isModalOpen);
          }
          toast.success('Application shortlisted successfully', {
            toastId: '1q9q',
          });
          fetchRequests(saveddata._id);
        }
      } catch (apiError) {
        toast.error('Failed to shortlist the application', {
          toastId: '19cwq',
        });
      }
    } catch (error) {
      console.error('Error in action function:', error);
    }
  };

  const actionReject = async (data, e) => {
    try {
      const paylod = {
        application_id: data?._id,
      };

      try {
        const response = await apiService.post(
          `announced-jobs/applicants/reject`,
          paylod
        );
        if (response?.code === 200) {
          if (e == true) {
            setIsModalOpen(!isModalOpen);
          }
          toast.success('Application rejected successfully', {
            toastId: '19wq',
          });
          fetchRequests(saveddata._id);
        }
      } catch (apiError) {
        toast.error('Failed to reject the application', { toastId: '19waq' });
      }
    } catch (error) {
      console.error('Error in actionReject function:', error);
    }
  };

  const draft = (e) => {
    localStorage.setItem('draftData', JSON.stringify(e));
    navigate('/Draft Contract');
  };
  const toggleModalreview = () => {
    setreviewModal(!reviewModal);
  };

  React.useEffect(() => {
    if (saveddata._id) {
      fetchRequests(saveddata._id, activeButton.toLowerCase());
    }
  }, [activeButton]);

  React.useEffect(() => {
    if (detailNodal !== '') {
      fetchData(detailNodal?.user?.physician?._id);
    }
  }, [detailNodal]);

  React?.useEffect(() => {
    if (view?.ratings?.length > 0) {
      setAnswer(view.ratings[0]);
    }
  }, [view?.ratings]);

  return (
    <div className="bg-[#f6f8fa] font-inter">
      {showModal && (
        <CustomModal onClose={() => setShowModal(false)} data={modalData} />
      )}

      <div className="p-4">
        <div className="relative ">
          {/* Overlay */}
          {isModalOpen && (
            <div
              onClick={toggleModal}
              className="fixed inset-0 bg-black bg-opacity-50 z-[999]" // Lower z-index
              aria-hidden="true"
            ></div>
          )}

          {/* Modal */}
          <div
            aria-hidden={!isModalOpen}
            className={`fixed top-0 right-0 overflow-auto h-full rounded w-64 w-[70%] bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${isModalOpen ? 'translate-x-0' : 'translate-x-full'} z-[999]`} // Lower z-index
          >
            <Modal
              isOpen={reviewModal}
              toggle={toggleModalreview}
              backdrop="static"
              className="max-w-lg mx-auto z-[10001]" // Updated z-index
              cssModule={{ 'modal-content': 'modal-content-for-reviews' }}
              centered
            >
              <ModalHeader
                toggle={toggleModalreview}
                cssModule={{ 'btn-close': 'btn-close-rating' }}
                className="flex justify-between"
              >
                <div className="flex items-center justify-between w-full gap-3">
                  <RiStarSmileLine
                    height={19}
                    width={20}
                    className={`self-center box-content p-2.5 border rounded-full`}
                    onClick={() => {
                      setreviewModal(!reviewModal);
                    }}
                  />
                  <h3
                    className={`font-medium text-base m-0 flex flex-col max-w-[280px] `}
                  >
                    <div>{`Rate Dr. ${view?.user?.firstName} ${
                      view?.user?.lastName
                    }`}</div>

                    <span className="font-normal text-sm text-[#525866]">
                      Provide us with feedback
                    </span>
                  </h3>
                </div>
              </ModalHeader>
              <ModalBody className="">
                {/* Main Rating */}
                <div className="flex justify-between border-b">
                  <div className="flex gap-3  pb-4 ">
                    <h3 className="text-[40px] font-medium mt-1.5">
                      {Number(view?.avg_rating || 0).toFixed(1)}
                    </h3>
                    <div className=" mt-2.5 h-[50px] self-strech bg-[#E2E4E9] w-[1px] " />
                    <div className=" mt-2">
                      <Rating
                        name="read-only"
                        value={view?.avg_rating}
                        readOnly
                        precision={0.5}
                      />
                      <div className="flex gap-2">
                        <p className="font-medium text-[#525866] m-0 underline cursor-pointer">
                          {view?.ratings?.length} reviews
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`text-[#525866] self-center cursor-pointer mt-[-32px] border rounded px-[5.42px] py-[5.42px] `}
                    onClick={() => setShowReviews(!showReviews)}
                  >
                    <FaChevronDown
                      className={`h-[9.55px] w-[9.55px] transition delay-50 duration-200 ease-in-out ${
                        showReviews ? 'rotate-180' : ''
                      } `}
                    />
                  </div>
                </div>

                {/* Reviews List */}
                {showReviews && (
                  <div className="space-y-4 mb-6 mt-6 overflow-y-auto h-[300px]">
                    {view?.ratings.map((review, index) => {
                      return (
                        <div
                          onClick={() => {
                            setAnswer(review);
                          }}
                          key={index}
                          className="border-b pb-2"
                        >
                          <div className="flex">
                            <h3 className="font-medium text-sm">
                              <span> {review.hospital_manager?.firstName}</span>{' '}
                              <span> {review.hospital_manager?.lastName}</span>
                            </h3>
                            <p className="ml-2 text-xs font-normal text-gray-500 self-center  ">
                              {review.date}
                            </p>
                          </div>

                          <div className="flex gap-2 ">
                            <Rating
                              name={`rating-${index}`}
                              value={review.avg_rating}
                              readOnly
                              precision={0.5}
                              size="medium"
                              className="ml-1"
                            />
                            <p className="text-sm font-normal text-gray-600 text-center self-center">
                              ({review.avg_rating})
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Rating Breakdown */}
                <div className="mt-4 mb-2">
                  <div className="flex w-full mt-2 gap-3 h-[20px]">
                    <div className="w-[338px] bg-[#F6F8FA] h-[12px] rounded-xs mt-[3.5px]">
                      <div
                        style={{ width: `${answer?.ratings?.[0]}0%` }}
                        className="bg-[#F2AE40] h-[12px]   rounded-xs"
                      ></div>
                    </div>
                    <div className="flex gap-2 ">
                      <span className=" text-sm font-normal slef-start">
                        {answer?.ratings?.[0]}
                      </span>
                      <StarIcon className="mt-[2.5px]" />
                    </div>
                  </div>
                  {/* DIVIDING BAR */}
                  <div className="flex w-full mt-2 gap-3 h-[20px]">
                    <div className="w-[338px] bg-[#F6F8FA] h-[12px] rounded-xs mt-[3.5px]">
                      <div
                        style={{ width: `${answer?.ratings?.[1]}0%` }}
                        className="bg-[#F2AE40] h-[12px]   rounded-xs "
                      ></div>
                    </div>
                    <div className="flex gap-2 ">
                      <span className=" text-sm font-normal slef-start">
                        {answer?.ratings?.[1]}
                      </span>
                      <StarIcon className="mt-[2.5px]" />
                    </div>
                  </div>
                  {/* DIVIDING BAR */}
                  <div className="flex w-full mt-2 gap-3 h-[20px]">
                    <div className="w-[338px] bg-[#F6F8FA] h-[12px] rounded-xs mt-[3.5px]">
                      <div
                        style={{ width: `${answer?.ratings?.[2]}0%` }}
                        className="bg-[#F2AE40] h-[12px]  rounded-xs "
                      ></div>
                    </div>
                    <div className="flex gap-2 ">
                      <span className=" text-sm font-normal slef-start">
                        {answer?.ratings?.[2]}
                      </span>
                      <StarIcon className="mt-[2.5px]" />
                    </div>
                  </div>
                  {/* DIVIDING BAR */}
                  <div className="flex w-full mt-2 gap-3 h-[20px]">
                    <div className="w-[338px] bg-[#F6F8FA] h-[12px] rounded-xs mt-[3.5px]">
                      <div
                        style={{ width: `${answer?.ratings?.[3]}0%` }}
                        className="bg-[#F2AE40] h-[12px]  rounded-xs  overflow-hidden"
                      ></div>
                    </div>
                    <div className="flex gap-2 ">
                      <span className=" text-sm font-normal slef-start">
                        {answer?.ratings?.[3]}
                      </span>
                      <StarIcon className="mt-[2.5px]" />
                    </div>
                  </div>
                  {/* DIVIDING BAR */}
                  <div className="flex w-full mt-2 gap-3 h-[20px]">
                    <div className="w-[338px] bg-[#F6F8FA] h-[12px] rounded-xs mt-[3.5px]">
                      <div
                        style={{ width: `${answer?.ratings?.[4]}0%` }}
                        className="bg-[#F2AE40] h-[12px]  rounded-xs "
                      ></div>
                    </div>
                    <div className="flex gap-2 ">
                      <span className=" text-sm font-normal slef-start">
                        {answer?.ratings?.[4]}
                      </span>
                      <StarIcon className="mt-[2.5px]" />
                    </div>
                  </div>
                </div>
              </ModalBody>
            </Modal>

            {/*
                        <button
                            onClick={toggleModal}
                            aria-label="Close Modal"
                            className="absolute top-4 left-4 text-gray-600"
                        >
                            Close
                        </button>*/}
            <div className="">
              <div class="flex items-center justify-between p-6">
                <div class="flex items-center">
                  <span class="text-gray-800 font-bold">
                    {detailNodal?.user?.physician?.firstArabicName ||
                      detailNodal?.user?.physician?.firstEnglishName}
                    {detailNodal?.user?.physician?.lastArabicName ||
                      detailNodal?.user?.physician?.lastEnglishName}
                  </span>

                  <div class="border-2 border-[#0A0D14] h-7 ml-4"></div>
                  <div class="ml-2 flex">
                    <span class="text-sm text-[#0A0D14] ml-2">
                      {avgRating ? (
                        <div className="flex items-center gap-1 text-yellow-500">
                          {/* <span className="text-sm font-medium">{avgRating}</span>
                                                     Render stars based on avgRating */}
                          <StarRating avgRating={avgRating} />
                        </div>
                      ) : (
                        <div class="ml-2 flex">
                          <svg
                            class="w-5 h-5 text-yellow-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                            ></path>
                          </svg>
                          <svg
                            class="w-5 h-5 text-yellow-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                            ></path>
                          </svg>
                          <svg
                            class="w-5 h-5 text-yellow-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                            ></path>
                          </svg>
                          <svg
                            class="w-5 h-5 text-yellow-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                            ></path>
                          </svg>
                          <svg
                            class="w-5 h-5 text-yellow-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                            ></path>
                          </svg>

                          <span class="text-sm text-[#0A0D14] ml-2">
                            0 Ratings
                          </span>
                        </div>
                      )}
                    </span>
                    <span
                      onClick={() => {
                        if (detailNodal?.user?.physician?.ratings?.length > 0) {
                          setreviewModal(true);
                        }
                      }}
                      className="text-sm text-[#525866] ml-2 underline"
                    >
                      {detailNodal?.user?.physician?.ratings?.length || 0}{' '}
                      reviews
                    </span>
                  </div>
                </div>

                <div class="flex space-x-2">
                  <button
                    class="bg-[white]  border-solid border-[2px] border-[#DF1C41] text-[#DF1C41] font-bold py-2 px-4 rounded-[12px]"
                    onClick={() => {
                      actionReject(detailNodal, true);
                    }}
                  >
                    Reject
                  </button>
                  <button
                    class="bg-[#008556] text-white font-bold py-2 px-4  rounded-[12px]"
                    onClick={() => action(detailNodal, true)}
                  >
                    Shortlist
                  </button>
                </div>
              </div>
              {isModalOpen && (
                <DetailForm
                  modal={false}
                  restictapi={true}
                  detailModal={detailNodal}
                />
              )}
            </div>
          </div>
        </div>

        {Loading ? (
          <div class="p-4 bg-white rounded-md">
            <div class="flex justify-between items-center border-b pb-2">
              <div class="flex items-center gap-2">
                <span class="flex items-center gap-1 px-2 py-1 text-sm font-semibold text-[#525866] bg-[#ffffff] border rounded">
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="8.84082" cy="8.33105" r="3" fill="#38C793" />
                  </svg>
                  {capitalizeFirstCharacter(savedData?.status)}
                </span>
                <span class="flex items-center gap-1 px-2 py-1 text-sm font-semibold text-[#525866] bg-[#ffffff] border rounded">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.818 4.51281L10.9696 5.36121C10.2826 4.67409 9.37851 4.24644 8.41151 4.15115C7.4445 4.05586 6.47437 4.29881 5.66641 4.8386C4.85845 5.3784 4.26265 6.18164 3.98053 7.11147C3.69841 8.0413 3.74742 9.04019 4.11922 9.93794C4.49101 10.8357 5.16258 11.5767 6.01951 12.0348C6.87643 12.493 7.86568 12.6398 8.81871 12.4503C9.77175 12.2608 10.6296 11.7467 11.2461 10.9956C11.8626 10.2445 12.1995 9.3029 12.1996 8.33121H13.3996C13.3996 9.58053 12.9664 10.7912 12.1738 11.7569C11.3813 12.7226 10.2784 13.3837 9.05306 13.6274C7.82774 13.8711 6.55583 13.6824 5.45403 13.0935C4.35224 12.5046 3.48873 11.5518 3.01065 10.3976C2.53256 9.24339 2.46948 7.95911 2.83214 6.76359C3.19481 5.56807 3.96079 4.53528 4.99956 3.8412C6.03834 3.14713 7.28564 2.8347 8.52894 2.95717C9.77224 3.07963 10.9346 3.6294 11.818 4.51281Z"
                      fill="#F27B2C"
                    />
                  </svg>

                  <span>
                    Hired {savedData?.hired ?? 0}/
                    {savedData?.no_of_practitioners ?? 0}
                  </span>
                </span>
                <h1 class="text-lg font-semibold ml-4">
                  {savedData?.medical_speciality?.name} Specialist
                </h1>
              </div>
              <span class="text-sm text-gray-500">
                REF-{savedData?.jobNumber}
              </span>
            </div>

            <div className="mb-6">
              {/* First Row with 5 columns */}
              <div className="grid grid-cols-5 gap-4 text-sm h-[120px]">
                <div className="border-r pt-4">
                  <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                    Date Posted
                  </p>
                  <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                    {new Date(savedData.created_at).toLocaleDateString('en-GB')}
                  </p>
                </div>
                <div className="border-r pt-4">
                  <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                    Location
                  </p>
                  <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                    {savedData?.creator?.sites?.[0]?.name}
                  </p>
                </div>
                <div className="border-r pt-4">
                  <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                    No Of Positions
                  </p>
                  <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                    {savedData?.no_of_practitioners}
                  </p>
                </div>
                <div className="border-r pt-4">
                  <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                    Level
                  </p>
                  <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                    {savedData?.medical_speciality?.name}
                  </p>
                </div>
                <div className="pt-4">
                  <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                    Expiry Date
                  </p>
                  <p className="text-[#AF1D38] font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                    {savedData?.till &&
                      new Date(savedData?.till).toLocaleDateString('en-GB')}
                  </p>
                </div>
              </div>

              {/* Second Row with 3 columns */}
              <div className="grid grid-cols-3 gap-4 text-sm border-t border-b h-[120px]">
                <div className="border-r pt-4">
                  <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                    Hospital Name
                  </p>
                  <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                    {savedData?.creator?.sites?.[0]?.name}
                  </p>
                </div>
                <div className="border-r pt-4">
                  <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                    Region
                  </p>
                  <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                    {savedData?.creator?.region.name}
                  </p>
                </div>
                <div className="pt-4">
                  <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                    CLuster
                  </p>
                  <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                    {savedData?.creator?.cluster.name}
                  </p>
                </div>
              </div>
            </div>

            {showDescription && (
              <div
                dangerouslySetInnerHTML={{ __html: savedData?.job_description }}
              />
            )}

            <button
              onClick={handleViewDetailsClick}
              class="w-full bg-[white] border-[#38C793] border-solid border-[2px] text-[#38C793] px-6 py-2 rounded-md shadow flex items-center justify-center gap-2 text-sm font-medium"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 00-2 0v3a1 1 0 001 1h3a1 1 0 100-2h-2V7z"
                  clip-rule="evenodd"
                />
              </svg>
              {showDescription ? 'Hide Details' : 'View Details'}
            </button>
          </div>
        ) : (
          <div className="p-4 bg-white rounded-md animate-pulse">
            <div className="flex justify-between items-center border-b pb-2">
              <div className="flex items-center gap-2">
                <div className="w-20 h-6 bg-gray-200 rounded"></div>
                <div className="w-32 h-6 bg-gray-200 rounded"></div>
                <div className="w-40 h-8 bg-gray-200 rounded ml-4"></div>
              </div>
              <div className="w-24 h-5 bg-gray-200 rounded"></div>
            </div>

            <div className="mb-6">
              <div className="grid grid-cols-5 gap-4 text-sm h-[120px]">
                {Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <div key={i} className="border-r pt-4">
                      <div className="w-20 h-4 bg-gray-200 rounded mb-2"></div>
                      <div className="w-32 h-6 bg-gray-300 rounded"></div>
                    </div>
                  ))}
              </div>

              <div className="grid grid-cols-3 gap-4 text-sm border-t border-b h-[120px] mt-4">
                {Array(3)
                  .fill(0)
                  .map((_, i) => (
                    <div key={i} className="border-r pt-4">
                      <div className="w-24 h-4 bg-gray-200 rounded mb-2"></div>
                      <div className="w-36 h-6 bg-gray-300 rounded"></div>
                    </div>
                  ))}
              </div>
            </div>

            <div className="w-full h-20 bg-gray-200 rounded mt-4"></div>

            <div className="mt-4">
              <div className="w-full bg-gray-200 border border-gray-300 px-6 py-2 rounded-md shadow flex items-center justify-center gap-2">
                <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
                <div className="w-24 h-5 bg-gray-300 rounded"></div>
              </div>
            </div>
          </div>
        )}

        <div class=" bg-white p-6 ">
          <div class="flex justify-between items-center mb-4 w-[220px]">
            <div class="flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-gray-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 11V7a4 4 0 10-8 0v4M5.457 18H18.54m-13.082 0A2.4 2.4 0 003 20.4v.2c0 .22.18.4.4.4h16.2c.22 0 .4-.18.4-.4v-.2a2.4 2.4 0 00-2.457-2.4"
                />
              </svg>
              <h3 class="text-lg font-semibold text-gray-800">
                Applicants List
              </h3>
            </div>
            <span class="bg-[#DF1C41] text-white px-2 py-1 rounded-full text-sm">
              0{savedData?.application_count}
            </span>
          </div>

          <div class="flex gap-6 text-sm bg-gray-50 rounded-md p-2 w-[340px]">
            <button
              onClick={() => {
                setActiveButton('All');
              }}
              className={`px-4 py-2 font-medium ${activeButton === 'All' ? 'text-black bg-white rounded-md shadow' : 'text-gray-500 hover:text-black'}`}
            >
              All
            </button>

            <button
              onClick={() => {
                setActiveButton('Shortlisted');
              }}
              className={`px-4 py-2 font-medium ${activeButton === 'Shortlisted' ? 'text-black bg-white rounded-md shadow' : 'text-gray-500 hover:text-black'}`}
            >
              Shortlisted
            </button>
            <button
              onClick={() => {
                setActiveButton('Rejected');
              }}
              className={`px-4 py-2 font-medium ${activeButton === 'Rejected' ? 'text-black bg-white rounded-md shadow' : 'text-gray-500 hover:text-black'}`}
            >
              Rejected
            </button>
          </div>

          <div className="w-full flex flex-wrap items-center gap-4">
            {filteredApplications?.length === 0 ? (
              <p className="text-gray-500 pr-5 pb-5 pt-5">
                No Applicant found.
              </p>
            ) : (
              filteredApplications?.map((data, index) => {
                const managerRating = data?.user?.physician;

                const avgRating = managerRating?.avg_rating;

                return (
                  <div key={index} className="pt-4 ">
                    <div class="bg-white p-4 rounded-lg shadow-md border border-gray-200 w-full min-w-[400px] flex flex-col">
                      <div class="flex items-center justify-between mb-4">
                        <div class="flex items-center gap-4">
                          <div class="bg-gray-200 text-gray-700 w-12 h-12 rounded-full flex items-center justify-center font-bold">
                            {`${data.user?.firstName?.charAt(0) || ''}${data.user?.lastName?.charAt(0) || ''}`}
                          </div>
                          <div>
                            <h4 class="font-semibold text-gray-800">
                              {data.user?.firstName} {data.user?.lastName}
                            </h4>
                            <div class="flex items-center gap-1 text-yellow-500">
                              {/* Empty stars 
                                                                // <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                                                                //     <path d="M12 2l2.94 7.06h7.41l-6 4.36 2.23 7.06L12 16.12l-6.58 4.36 2.23-7.06-6-4.36h7.41L12 2z" />
                                                                // </svg>*/}
                              <div>
                                {avgRating ? (
                                  <div className="flex items-center gap-1 text-yellow-500">
                                    {/* Render stars based on avgRating */}
                                    <StarRating avgRating={avgRating} />
                                  </div>
                                ) : (
                                  <div class="ml-2 flex">
                                    <svg
                                      class="w-5 h-5 text-yellow-400"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                                      ></path>
                                    </svg>
                                    <svg
                                      class="w-5 h-5 text-yellow-400"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                                      ></path>
                                    </svg>
                                    <svg
                                      class="w-5 h-5 text-yellow-400"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                                      ></path>
                                    </svg>
                                    <svg
                                      class="w-5 h-5 text-yellow-400"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                                      ></path>
                                    </svg>
                                    <svg
                                      class="w-5 h-5 text-yellow-400"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                                      ></path>
                                    </svg>

                                    <span class="text-sm text-[#0A0D14] ml-2">
                                      0 Ratings
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <button class="text-gray-400 hidden hover:text-red-500">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 011.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </button>
                      </div>

                      <div class="flex flex-col md:flex-row border p-4 rounded-md text-sm">
                        <div class="flex-1 border-r md:pr-4 mb-4 md:mb-0">
                          <p class="font-medium text-[#868C98]">Nationality</p>
                          <p class="text-[#0A0D14] font-medium">
                            {data?.user?.physician?.nationality}
                          </p>
                        </div>
                        <div class="flex-1 md:pl-4">
                          <p class="font-medium text-[#868C98]">Practitioner</p>
                          <p class="text-[#0A0D14] font-medium">
                            {data?.user?.physician?.practitionerLevels}
                          </p>
                        </div>
                      </div>

                      {user.role == 'hospital_manager' && (
                        <div className="flex flex-col md:flex-row items-center gap-2 justify-between mt-4">
                          {data?.status !== 'rejected' ? (
                            <>
                              <button
                                onClick={() =>
                                  data?.status === 'shortlisted'
                                    ? window.open(
                                        `https://mail.google.com/mail`,
                                        '_blank'
                                      )
                                    : actionReject(data, false)
                                }
                                className={`flex items-center justify-center gap-2 bg-white ${
                                  data?.status === 'shortlisted'
                                    ? 'text-[#525866]'
                                    : 'text-[#DF1C41]'
                                } font-medium px-4 py-2 rounded-md border w-[44%]`}
                              >
                                {data?.status === 'shortlisted' ? (
                                  <svg
                                    width="15"
                                    height="14"
                                    viewBox="0 0 15 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M5.5245 6.0115C6.22825 7.24786 7.25214 8.27175 8.4885 8.9755L9.1515 8.047C9.25812 7.8977 9.41576 7.79266 9.5946 7.75175C9.77344 7.71084 9.96108 7.7369 10.122 7.825C11.1827 8.40469 12.3542 8.75333 13.5592 8.848C13.7473 8.8629 13.9229 8.94815 14.0509 9.08674C14.1789 9.22533 14.25 9.40708 14.25 9.59575V12.9423C14.25 13.1279 14.1812 13.3071 14.0568 13.4449C13.9324 13.5828 13.7612 13.6696 13.5765 13.6885C13.179 13.7297 12.7785 13.75 12.375 13.75C5.955 13.75 0.75 8.545 0.75 2.125C0.75 1.7215 0.77025 1.321 0.8115 0.9235C0.830441 0.738773 0.917238 0.567641 1.05509 0.443225C1.19295 0.31881 1.37205 0.24996 1.55775 0.25H4.90425C5.09292 0.249976 5.27467 0.321064 5.41326 0.449088C5.55185 0.577112 5.63709 0.752668 5.652 0.94075C5.74667 2.14584 6.09531 3.31726 6.675 4.378C6.7631 4.53892 6.78916 4.72656 6.74825 4.9054C6.70734 5.08424 6.6023 5.24188 6.453 5.3485L5.5245 6.0115Z"
                                      fill="#525866"
                                    />
                                  </svg>
                                ) : (
                                  <svg
                                    width="20"
                                    height="20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M9.99956 8.93955L13.7121 5.22705L14.7726 6.28755L11.0601 10.0001L14.7726 13.7126L13.7121 14.7731L9.99956 11.0606L6.28706 14.7731L5.22656 13.7126L8.93906 10.0001L5.22656 6.28755L6.28706 5.22705L9.99956 8.93955Z"
                                      fill="#DF1C41"
                                    />
                                  </svg>
                                )}
                                {data?.status === 'shortlisted'
                                  ? 'Call'
                                  : 'Reject'}
                              </button>

                              <button
                                onClick={() =>
                                  data?.status === 'shortlisted'
                                    ? draft(data)
                                    : action(data, false)
                                }
                                disabled={data?.is_drafted}
                                className={`flex items-center justify-center gap-2 bg-[#2D9F75] ${data?.is_drafted ? 'cursor-not-allowed bg-gray-200' : 'cursor-text'} text-white font-medium px-4 py-2 rounded-md w-full md:w-auto`}
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.49956 12.3791L15.3936 5.48438L16.4548 6.54488L8.49956 14.5001L3.72656 9.72712L4.78706 8.66663L8.49956 12.3791Z"
                                    fill="white"
                                  />
                                </svg>
                                {data?.status === 'shortlisted'
                                  ? 'Draft Contract'
                                  : 'ShortList'}
                              </button>

                              {data?.status !== 'shortlisted' && (
                                <button
                                  onClick={() => toggleModal(data)}
                                  className="flex items-center justify-center bg-white font-medium w-[70px] h-[40px] border rounded-md"
                                >
                                  <img
                                    src={im}
                                    alt="logo"
                                    className="w-auto h-auto max-w-full max-h-full"
                                  />
                                </button>
                              )}
                            </>
                          ) : (
                            <button
                              className={`flex border border-[#DF1C41] border-solid border-2 items-center justify-center gap-2 bg-white ${'text-[#DF1C41]'} font-medium px-4 py-2 rounded-md border w-[38%]`}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M16.6668 16.6673L3.3335 3.33398M16.6668 3.33398L3.3335 16.6673"
                                  stroke="#DF1C41"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                />
                              </svg>

                              {'Rejected'}
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementDetail;

// {(rejection && <ReasonOfRejection setRejection={setRejection} rejectionReason={handleReject} />)}
